import { ModuleFE_BaseApi } from '@nu-art/thunderstorm-frontend/index';
import { ThunderDispatcherV3 } from '@nu-art/thunderstorm-frontend/core/db-api-gen/types';
import { DBDef_PushSubscription } from '@nu-art/push-pub-sub-shared/push-subscription/index';
export const dispatch_onSubscriptionChanged = new ThunderDispatcherV3('__onSubscriptionUpdated');
export class ModuleFE_PushSubscription_Class extends ModuleFE_BaseApi {
    constructor() {
        super(DBDef_PushSubscription, dispatch_onSubscriptionChanged);
    }
}
export const ModuleFE_PushSubscription = new ModuleFE_PushSubscription_Class();
//# sourceMappingURL=ModuleFE_PushSubscription.js.map